import { render, staticRenderFns } from "./BaseInputEasySlider.vue?vue&type=template&id=673807f4&scoped=true&"
import script from "./BaseInputEasySlider.vue?vue&type=script&lang=ts&"
export * from "./BaseInputEasySlider.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInputEasySlider.vue?vue&type=style&index=0&id=673807f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673807f4",
  null
  
)

export default component.exports